import { Elm } from "./Main.elm";

var app = Elm.Main.init({
  flags: { baseUrl: window.APP.BASE_URL },
});

if (app.ports && app.ports.outgoing) {
  app.ports.outgoing.subscribe(({ tag, data }) => {
    // Initialize Calendly widget with user prefill data
    // This is only called after Elm has verified the iframe exists in DOM
    if (tag === "PUSH_STEP_CHANGED") {
      if (window.APP.GOOGLE_TAG_MANAGER_ENABLED) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "intake_form_step",
          step: data.step,
          prevStep: data.prevStep,
          userId: data.userId,
        });
      }
    }

    // Initialize Calendly widget with user prefill data
    // This is only called after Elm has verified the iframe exists in DOM
    if (tag === "CALENDLY_WIDGET_INIT") {
      const iframe = document.getElementById(data.iframeId);
      if (iframe) {
        // Send prefill data to the Calendly iframe
        iframe.contentWindow.postMessage(
          {
            event: "CALENDLY_WIDGET_INIT",
            prefill: data.prefill, // Contains user's name and email
          },
          "*",
        );
      }
    }
  });
}

// Listen for messages from Calendly iframe and forward to Elm
if (app.ports && app.ports.incoming) {
  window.addEventListener("message", function (event) {
    // Calendly widget has finished loading. This has been the only reliable method of checking
    // if the iframe is loaded and the Calendly javascript has been executed.
    if (event.data.event && event.data.event === "CALENDLY_LOADED") {
      app.ports.incoming.send("CALENDLY_LOADED");
    }
    // User scheduled an appointment - forward this message to ELM so it can redirect to thank you page
    if (event.data.event && event.data.event === "CALENDLY_EVENT_SCHEDULED") {
      app.ports.incoming.send("CALENDLY_EVENT_SCHEDULED");
    }
  });
}
